<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" fill="none" viewBox="0 0 24 25">
  <path stroke="#000" d="M13.084 16.972l-3.976 3.976a3.578 3.578 0 11-5.06-5.06l4.337-4.338a3.578 3.578 0 015.06 0l1.055.946M10.916 9.02l3.976-3.976a3.578 3.578 0 015.06 5.06l-4.338 4.338a3.578 3.578 0 01-5.06 0L9.5 13.496"/>
</svg>
